var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPublications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8028 18.5H28.1955C25.325 18.5 22.998 20.827 22.998 23.6975V37.8025C22.998 40.673 25.325 43 28.1955 43H37.8028C40.6733 43 43.0002 40.673 43.0002 37.8025V23.6975C43.0002 20.827 40.6733 18.5 37.8028 18.5Z",
    fill: "#804419"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3723 23.75C20.3762 21.7113 21.1759 19.7547 22.6011 18.2969C24.0262 16.839 25.9641 15.9952 28.0022 15.945V13.25C28.0022 11.8576 27.4491 10.5223 26.4645 9.53769C25.48 8.55312 24.1446 8 22.7523 8H13.2499C11.8576 8 10.5222 8.55312 9.53767 9.53769C8.55311 10.5223 8 11.8576 8 13.25V27.25C8 28.6424 8.55311 29.9777 9.53767 30.9623C10.5222 31.9469 11.8576 32.5 13.2499 32.5H20.4248L20.3723 23.75Z",
    fill: "#CB2110"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2273 29.4375H34.6874V27.8975C34.6874 27.5494 34.5491 27.2155 34.303 26.9694C34.0568 26.7232 33.723 26.585 33.3749 26.585C33.0268 26.585 32.693 26.7232 32.4468 26.9694C32.2007 27.2155 32.0624 27.5494 32.0624 27.8975V29.4375H30.5224C30.1743 29.4375 29.8405 29.5757 29.5944 29.8219C29.3482 30.068 29.21 30.4019 29.21 30.75C29.21 31.0981 29.3482 31.4319 29.5944 31.678C29.8405 31.9242 30.1743 32.0625 30.5224 32.0625H32.0624V33.6025C32.0624 33.9506 32.2007 34.2844 32.4468 34.5305C32.693 34.7767 33.0268 34.915 33.3749 34.915C33.723 34.915 34.0568 34.7767 34.303 34.5305C34.5491 34.2844 34.6874 33.9506 34.6874 33.6025V32.0625H36.2273C36.5754 32.0625 36.9093 31.9242 37.1554 31.678C37.4016 31.4319 37.5398 31.0981 37.5398 30.75C37.5398 30.4019 37.4016 30.068 37.1554 29.8219C36.9093 29.5757 36.5754 29.4375 36.2273 29.4375V29.4375Z",
    fill: "#FEF8E7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublications);
export default __webpack_public_path__ + "static/media/Publications.410fc316f757a955f0568dfc9262143c.svg";
export { ForwardRef as ReactComponent };